<template>
  <header class="wrap-header" v-if="!isPublic || isAuthenticated">
    <div class="row">
      <div class="sm-12 flex justify-between align-center collapse">
        <div v-if="!isPublic || isAuthenticated">
          <a href="javascript:void(0)" class="btn" @click="toggleDrawer" v-if="$route.path !== '/'">
            <i class="mdi mdi-arrow-left"></i>
          </a>
          <a class="btn" v-if="$route.path !== '/'" @click="homeRedirect">
            <i class="mdi mdi-home"></i>
          </a>
        </div>

        <!--<a href="javascript:void(0)" class="btn" @click="voltar" v-else>
            <i class="mdi mdi-arrow-left"></i>
        </a>-->

        <img :src="logo" class="logo" @click="homeRedirect" />

        <!--
        <a href="javascript:void(0)" class="btn" @click="voltar">
            <i class="mdi mdi-home"></i>
        </a>
        <a href="javascript:void(0)" class="btn" @click="logout">
            <i class="mdi mdi-logout"></i>
        </a>
        -->
        <!-- <a class="btn visible-lg"></a> -->
        <label class="btn btn-toggle-drawer" v-if="!isPublic || isAuthenticated">
          <i class="mdi mdi-menu"></i>
          <input type="checkbox" value="1" v-model="drawer" />
        </label>
      </div>
    </div>
    

  </header>
  <header class="wrap-header header-home flex justify-center" v-else>
    <img :src="logo" class="logo" />

    <!-- <label class="btn btn-toggle-drawer" style="width: 96px">
      <i class="mdi mdi-menu"></i>
      <input type="checkbox" value="1" v-model="drawer" />
    </label> -->
  </header>
</template>
<script>

export default {
  components: {
    
  },
  methods: {
    voltar() {
      this.$router.go(-1);
    },
    toggleDrawer() {
      // Altera o estado da drawer baseado no estado atual
      if (this.drawer) {
        //this.$store.dispatch("hideDrawer");
        this.$router.back();
      } else {
        //this.$store.dispatch("showDrawer");
        this.$router.push("/menu");
      }
    },
    homeRedirect() {
      this.$store.dispatch("hideDrawer");
      this.$router.push("/");
    },
    async logout() {
      try {
        await Promise.all([
          this.$store.dispatch("setCliente", {}),
          this.$store.dispatch("setRelacoes", []),
          this.$store.dispatch("setRelacaoId", 0),
          this.$store.dispatch("setCondominioId", 0),
          this.$store.dispatch("setContratoId", 0),
          this.$store.dispatch("setImovelId", 0),
          this.$store.dispatch("setRefreshToken", null),
        ]);

        this.$router.replace("/login");
      } catch (error) {
        console.error(error);
      }
    },
  },
  computed: {
    empresa() {
      return this.$store.state.empresa;
    },
    logo() {
      return this.empresa.imgs.logo;
    },
    drawer: {
      get() {
        return !!this.$store.state.drawer;
      },
      set(value) {
        if (!!value) {
          //return this.$store.dispatch("showDrawer");
          this.$router.push("/menu");
          return;
        }
        //this.$store.dispatch("hideDrawer");
        this.$router.back();
      },
    },
    isMainScreen() {
      return !!this.$route.meta.isMainScreen;
    },
    isPublic() {
      return !!this.$route.meta.isPublic;
    },
    isAuthenticated() {
      return !!this.$store.getters.isAuthenticated;
    },
  },
};
</script>
<style lang="less">
@import "/css/colors.less";

.wrap-header {
  grid-area: header;
  background-color: var(--primary);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.7);
  //display: flex;
  //flex-direction: row;
  //justify-content: space-between;
  //align-items: center;
  color: white;
  padding-top: 10px;

  @media (max-width: 60em) {
    padding-top: 0;
  }

  .collapse {
    padding-left: 0;
    padding-right: 0;
  }

  img.logo {
    display: inline-block !important;
    height: 62px;
    cursor: pointer;

    @media (max-width: 60em) {
      height: 50px;
    }
  }

  &.header-home {
    justify-content: center;
    padding-top: 20px;

    img {
      max-height: 82px;
    }
  }

  h1 {
    font-size: 16px;
    font-weight: bold;
  }

  .btn {
    cursor: pointer;
  }

  .btn,
  span {
    text-decoration: none;
    color: white;
    box-sizing: border-box;
    border-radius: 0.25em;
    padding: 1em;
    font-size: 12px;
    margin: 0.5em;
    width: 48px;
    text-align: center;
    i {
      font-size: 32px;
      line-height: 1;
    }
    [type="checkbox"] {
      display: none;
    }

    @media(max-width: 330px) {
      display: inline-block;
      margin: 0;
      padding: 16px 4px;
      width: auto;
    }
  }
  span {
    border: 1px solid transparent;
  }
}

.btn-toggle-drawer {
  cursor: pointer;
}

// @media screen and (min-width: 60em) {
//   .btn-toggle-drawer {
//     display: none;
//   }
// }

.easy-money {
  header.wrap-header {
    img.logo {
      max-height: 50px;
      height: 50px;
      width: auto;
      display: inline-block !important;
    }
  }
}
</style>
